import { DADOS_VAZIOS } from "@/modules/visitantes/components/FormularioVisitante";
import {
  novaLinhaFamiliar,
  type LinhaFamiliar,
} from "@/modules/visitantes/components/FormularioFamilia";
import type {
  DadosSobre,
  DadosVisitante,
  FamiliarPendente,
  Indicacao,
  VisitanteFicha,
} from "@/modules/visitantes/services/visitantesService";
import { SOBRE_VAZIO, mesmasRespostas } from "@/modules/visitantes/utils/familia";
import { soEstadoCivil } from "@/modules/visitantes/utils/regras";
import { soSexo } from "@/shared/lib/sexo";

/** Ficha completa (ministério responsável) -> valores iniciais do formulário de edição. */
export function fichaParaDados(f: VisitanteFicha): DadosVisitante {
  return {
    ...DADOS_VAZIOS,
    nome: f.nome,
    telefone: f.telefone ?? "",
    email: f.email ?? "",
    estadoCivil: soEstadoCivil(f.estado_civil),
    sexo: soSexo(f.sexo),
    nascimento: f.nascimento ?? "",
    respNome: f.resp_nome ?? "",
    respTelefone: f.resp_telefone ?? "",
    igrejaSituacao:
      f.igreja_situacao === "outra" || f.igreja_situacao === "sem" ? f.igreja_situacao : "",
    igrejaNome: f.igreja_nome ?? "",
    cidade: f.cidade ?? "",
    bairro: f.bairro ?? "",
    endereco: f.endereco ?? "",
    preferenciaContato:
      f.preferencia_contato === "visita" ||
      f.preferencia_contato === "contato" ||
      f.preferencia_contato === "nao"
        ? f.preferencia_contato
        : "",
    pedidoOracao: f.pedido_oracao ?? "",
    observacao: f.observacao ?? "",
  };
}

const soSituacao = (v: string | null | undefined): DadosSobre["igrejaSituacao"] =>
  v === "outra" || v === "sem" ? v : "";
const soPreferencia = (v: string | null | undefined): DadosSobre["preferenciaContato"] =>
  v === "visita" || v === "contato" || v === "nao" ? v : "";

/** Familiares guardados no Visitante pendente -> linhas da etapa 2 (edição do autor). */
export function familiaresParaLinhas(i: Indicacao): LinhaFamiliar[] {
  const base = indicacaoParaDados(i);
  return (i.familiares ?? []).map((f: FamiliarPendente) => {
    const sobre: DadosSobre = {
      ...SOBRE_VAZIO,
      igrejaSituacao: soSituacao(f.igreja_situacao),
      igrejaNome: f.igreja_nome ?? "",
      cidade: f.cidade ?? "",
      bairro: f.bairro ?? "",
      endereco: f.endereco ?? "",
      preferenciaContato: soPreferencia(f.preferencia_contato),
      pedidoOracao: f.pedido_oracao ?? "",
    };
    return {
      ...novaLinhaFamiliar(),
      parentesco: f.parentesco,
      nome: f.nome,
      nascimento: f.nascimento,
      sexo: soSexo(f.sexo),
      // Pendente salvo antes do campo existir: sexo opcional na edição.
      sexoOpcional: soSexo(f.sexo) === "",
      telefone: f.telefone ?? "",
      estadoCivil: soEstadoCivil(f.estado_civil),
      sobre,
      mesmas: mesmasRespostas(base, sobre),
    };
  });
}

/** Visitante pendente (líder) -> valores iniciais do formulário de edição ou da avaliação. */
export function indicacaoParaDados(i: Indicacao): DadosVisitante {
  return {
    ...DADOS_VAZIOS,
    nome: i.nome,
    telefone: i.telefone ?? "",
    email: i.email ?? "",
    estadoCivil: soEstadoCivil(i.estado_civil),
    sexo: soSexo(i.sexo),
    nascimento: i.nascimento ?? "",
    dataVisita: i.data_visita,
    respNome: i.resp_nome ?? "",
    respTelefone: i.resp_telefone ?? "",
    igrejaSituacao:
      i.igreja_situacao === "outra" || i.igreja_situacao === "sem" ? i.igreja_situacao : "",
    igrejaNome: i.igreja_nome ?? "",
    cidade: i.cidade ?? "",
    bairro: i.bairro ?? "",
    endereco: i.endereco ?? "",
    preferenciaContato:
      i.preferencia_contato === "visita" ||
      i.preferencia_contato === "contato" ||
      i.preferencia_contato === "nao"
        ? i.preferencia_contato
        : "",
    pedidoOracao: i.pedido_oracao ?? "",
    observacao: i.nota ?? "",
    ministerioId: i.ministerio_id ?? "",
  };
}
